<template>
    <div class="filter" id="filter">
        <div class="modal-dialog modal-filter-dialog">
            <div class="modal-inner">
                <button type="button" class="btn-close btn-close-filter btn-close-modal">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#close" />
                    </svg>
                </button>
                <div class="filter-main-block" id="filter-main-block">
                    <div class="filter-title-row">  
                        <div class="filter-title">{{ trans('filter.filters') }}</div>
                        <button @click="cleanFilter" type="button" class="btn-filer-clear">
                            {{ trans('filter.clean_filters') }}
                        </button>
                    </div>
                    <div class="filter-body">
                        <div class="filter-row">    
                            <div class="filter-name">
                                {{ trans('filter.sort_by') }}
                            </div>
                            <div class="filter-amount"> 
                                
                                <label class="label-radio">
                                    <input value="default" type="radio" v-model="data.sort" name="sort">
                                    <span class="radio"></span>
                                    <span class="text">{{ trans('filter.default') }}</span>
                                </label>
                                <label class="label-radio">
                                    <input value="minToMax" type="radio" v-model="data.sort" name="sort">
                                    <span class="radio"></span>
                                    <span class="text">{{ trans('filter.from_min_to_max') }}</span>
                                </label>
                                <label class="label-radio">
                                    <input value="maxToMin" type="radio" v-model="data.sort" name="sort">
                                    <span class="radio"></span>
                                    <span class="text">{{ trans('filter.from_max_to_min') }}</span>
                                </label>
                                <label class="label-radio">
                                    <input value="MaxSaleToMinSale" type="radio" name="sort">
                                    <span class="radio"></span>
                                    <span class="text">{{ trans('filter.from_max_to_min_sale') }}</span>
                                </label>
                            </div>
                        </div>
                        
                        <div class="filter-row filter-price-row">    
                            <div class="filter-name">
                                {{ trans('filter.price') }}
                            </div>
                            <div class="filter-price">
                                <label class="label-field label-field-char">
                                    <span class="field-name">{{ trans('filter.from') }}</span>
                                    <input type="number" min="0" :max="max_price" v-model="data.priceMin">
                                    <span class="char">₴</span>
                                </label>
                                <span class="to-separator">
                                    -
                                </span>
                                <label class="label-field label-field-char">
                                    <span class="field-name">{{ trans('filter.to') }}</span>
                                    <input type="number" min="0" :max="max_price" v-model="data.priceMax">
                                    <span class="char">₴</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-bottom">
                    <button type="button" @click="confirm()" class="btn btn-close-filter btn-close-modal">
                        {{ trans('filter.show_products') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mixins: [],
    components: {

    },
    props: {
        max_price: {
            requeired: false,
            default: 0
        },
        min_price: {
            requeired: false,
            default: 0
        },
        get_filter: {
            requeired: false,
            default: 0
        }
    },
    watch: {
        // data: {
        //     handler(val){
        //         this.$emit("change", val);
        //     },
        //     deep: true
        // },
    },
    data() {
        return {
            clickedItem: null,
            data: {
                categories: [],
                priceMin: this.get_filter.priceMin,
                priceMax: this.get_filter.priceMax,
                sort: 'default'
            }
        }
    },
    beforeMount() {
    },
    mounted() {
    },
    methods: {
        confirm() {
            this.$emit("change", this.data);
            document.getElementById('filter').classList.remove('modal-open');
        },
        cleanFilter() {
            for (const [key, value] of Object.entries(this.data)) {
                if (key == 'priceMax') {
                    this.data[key] = this.max_price;
                } else if (key == 'priceMin') {
                    this.data[key] = this.min_price;
                } else if (key == 'sort') {
                    this.data[key] = 'default'
                }
            }
        }
    }
}
</script>